<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button @click="openServerModal = true" class="md-just-icon md-round md-simple md-toolbar-toggle">
          <svg style="margin-top: 13px;" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-120q-151 0-255.5-46.5T120-280v-400q0-66 105.5-113T480-840q149 0 254.5 47T840-680v400q0 67-104.5 113.5T480-120Zm0-479q89 0 179-25.5T760-679q-11-29-100.5-55T480-760q-91 0-178.5 25.5T200-679q14 30 101.5 55T480-599Zm0 199q42 0 81-4t74.5-11.5q35.5-7.5 67-18.5t57.5-25v-120q-26 14-57.5 25t-67 18.5Q600-528 561-524t-81 4q-42 0-82-4t-75.5-11.5Q287-543 256-554t-56-25v120q25 14 56 25t66.5 18.5Q358-408 398-404t82 4Zm0 200q46 0 93.5-7t87.5-18.5q40-11.5 67-26t32-29.5v-98q-26 14-57.5 25t-67 18.5Q600-328 561-324t-81 4q-42 0-82-4t-75.5-11.5Q287-343 256-354t-56-25v99q5 15 31.5 29t66.5 25.5q40 11.5 88 18.5t94 7Z"/></svg>
        </md-button>
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <li style="width: 140px; padding: 0 10px;" v-if="sysOptions.length > 1">
              <md-field>
                <md-select v-model="user_sys">
                  <md-option v-for="item in sysOptions" :key="item.sys" :value="item.sys">{{item.name}}</md-option>
                </md-select>
              </md-field>
            </li>
            <li style="width: 200px; padding: 0 10px;" v-if="datacenterOptions.length > 1">
              <md-field>
                <md-select v-model="user_datacenter_id">
                  <md-option v-for="item in datacenterOptions" :key="item.id" :value="item.id">{{item.name}}</md-option>
                </md-select>
              </md-field>
            </li>
            <md-list-item v-if="showBalance" @click="() => {show_balance = !show_balance}">
              <p :style="{'line-height': '0px', 'font-size': '14px', 'font-family': 'Roboto, Helvetica, Arial, font-family'}">{{$I18n("balance")}}: {{show_balance ?balance :"****"}} </p>
            </md-list-item>
            <md-list-item v-if="host === 'open.kdzn.top'" @click="goDoc">
              <p class="" :style="{ 'font-size': '14px','line-height': '0px'}">{{$I18n("document")}}</p>
            </md-list-item>
            <li v-if="host === 'open.kdzn.top'" class="md-list-item">
              <a class="md-list-item-router md-list-item-container md-button-clean dropdown">
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>language</md-icon>
                      <p class="hidden-lg hidden-md">{{$I18n("language")}}</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li><a href="#" @click="changeLanguage('zh')">中文</a></li>
                      <li><a href="#" @click="changeLanguage('en')">English</a></li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <li class="md-list-item">
              <a class="md-list-item-router md-list-item-container md-button-clean dropdown">
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>person</md-icon>
                      <p class="hidden-lg hidden-md">{{$I18n("personal_info")}}</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li @click="changeMenuName($I18n('personal_info'))">
                        <router-link :to="{path:'/user/info', query: {...$router.history.current.query}}">
                          <p :style="{'margin':0}" >
                            {{$I18n("personal_info")}}
                          </p>
                        </router-link>
                      </li>
                      <!-- <li @click="changeMenuName($I18n('bills'))" v-if="showBalance">
                        <router-link :to="{path:'/user/bills', query: {...$router.history.current.query}}">
                          <p :style="{'margin':0}" >
                            {{$I18n("bills")}}
                          </p>
                        </router-link>
                      </li> -->
                      <li><a href="#" @click="checkExit">{{$I18n("logout")}}</a></li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
          </md-list>
        </div>
      </div>
    </div>
    <modal 
      v-show="openModal" 
      @close="modal_classicModalHide" 
      class="lg-modal" 
    >
      <template slot="header">
        <h4 class="modal-title">{{$I18n("logout")}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_classicModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        {{$I18n("check_logout")}}
      </template>
      <template slot="footer">
        <md-button :style="{'margin-right':'16px'}" class="md-info" @click="modal_submit">{{$I18n("sure")}}</md-button>
        <md-button class="left-icon" @click="modal_classicModalHide">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
    <modal 
      v-show="openServerModal" 
      @close="modal_classicModalHide" 
    >
      <template slot="header">
        <h4 class="modal-title">{{$I18n("datacenter")}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_classicModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div>
          <md-field>
            <md-select v-model="user_sys">
              <md-option v-for="item in sysOptions" :key="item.sys" :value="item.sys">{{item.name}}</md-option>
            </md-select>
          </md-field>
          <md-field>
            <md-select v-model="user_datacenter_id">
              <md-option v-for="item in datacenterOptions" :key="item.id" :value="item.id">{{item.name}}</md-option>
            </md-select>
          </md-field>
        </div>
      </template>
      <template slot="footer">
        <md-button class="left-icon" @click="modal_classicModalHide">{{$I18n("closed")}}</md-button>
      </template>
    </modal>
  </md-toolbar>
</template>

<script>

import { Modal } from '@/components';

export default {
  components: {
    Modal,
  },
  props : {
    name : {
      type :String,
      default:"",
    },
    role : {
      type : Number,
      default: -1,
    },
    sys  : {
      default : "",
    },
  },
  created(){
    this.api_getBalace();
    this.api_getSys()
      // .then(this.api_getDatabase);
    window.__regetBalace = this.api_getBalace;
  },
  data() {
    return {
      host: window.location.host,
      balance : 0,
      show_balance : false,
      openModal: false,
      openServerModal: false,
      selectedEmployee: "",

      user_sys : "",
      sysOptions : [],
      user_datacenter_id: "",
      datacenterOptions : [],
    };
  },
  computed:{
    showBalance(){
      return this.role !== -1 && ((this.role < 10010) || this.role === 11000 || this.role === 12000)
    },
    user_datacenter(){
      if(this.datacenterOptions.length === 0 || !this.user_datacenter_id){
        return "_"
      }
      let item = this.datacenterOptions.filter(i => i.id == this.user_datacenter_id)[0];
      if(!item){
        return "_";
      }
      if(!item.ssl_port || item.ssl_port == "443" || item.ssl_port == "80"){
        return `https://${item.domain}`;
      }
      return `https://${item.domain}:${item.ssl_port}`;
    },
  },
  watch:{
    user_sys(newValue){
      this.$emit("changeSys", newValue);
      this.api_getDatabase();
    },
    user_datacenter(newValue){
      if(newValue === "_"){
        this.user_sys = this.sys;
        console.error("该Datacenter不存在");
        return
      }
      this.$emit("changeDatabase", newValue)
      this.$root.state.apiurl = newValue + "/api";
      this.api_getBalace();
    },
    // "$root.state.apiurl":{
    //   handler(){
    //     this.api_getSys().then(this.api_getDatabase)
    //   }
    // },
    "$root.state.toggle_datacenter":{
      handler(newValue, oldValue){
        if(!newValue === oldValue){
          this.api_getDatabase();
        }
      },
      immediate: true,
      deep: true,
    },
    'role':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    api_getDatabase(){
      if(!this.user_sys || !localStorage.acc_token){
        return;
      }
      var _apiurl = "";
      if(this.sysOptions && this.sysOptions.length > 0){
        var filterSys = this.sysOptions.filter(i => {
          return i.sys === this.user_sys;
        })
        if(filterSys.length > 0){
          _apiurl = `${window.location.protocol}//${filterSys[0].api_addr}:${filterSys[0][window.location.protocol === "https:" ?"api_ssl_port" :"api_port"]}/api`;
        }
      }
      return this.$api.getSysList_ver2({
        _apiurl: _apiurl,
        type: "datacenter",
        option : {
          sys: this.user_sys,
        }
      })
        .then(this.$Then(res => {
          this.datacenterOptions = res.data;
          if(res.data.length > 0){
            if (this.datacenterOptions.some(i => i.id == this.user_datacenter_id)) {
              return
            }
            if(this.UserInfo && this.UserInfo.zone){
              const zoneCenter = res.data.filter(i => {
                return i.zone === this.UserInfo.zone;
              })[0]
              if(zoneCenter && zoneCenter.id){
                this.user_datacenter_id = zoneCenter.id
                return
              }
            }
            this.user_datacenter_id = res.data[0].id;
          } else {
            this.user_datacenter_id = "";
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.datacenterOptions = [];
          this.user_datacenter = "";
        }))
    },
    api_getSys(){
      if(!localStorage.acc_token){
        return
      }
      return this.$api.getSysList({
        type  : "sys",
        option: {},
      })
        .then(this.$Then(res => {
          this.sysOptions = res.data;
          if(!this.user_sys){
            this.user_sys = this.sys;
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.sysOptions = [];
        }))
    },
    goDoc(){
      window.open(this.$router.history.current.query.lang == 'en'?'https://docs.kdzn.top/en' : 'https://docs.kdzn.top/zh')
    },
    api_getBalace(){
      this.$api.getBalance({})
        .then(this.$Then(res => {
          this.balance = ""
          const json = JSON.parse(res.data?.money ?? '{}')
          for(var key in json){
            this.balance = this.balance + (this.balance ?", " :"") + this.$I18n("curr_" + key) + ": " + json[key]
          }
          if(this.balance === ""){
            this.balance = "0"
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    changeMenuName(name){
      this.$emit('changeName', name)
    },
    modal_submit(){
      this.$api.logout({})
        .then(this.$Then(() => {
          localStorage.acc_token = ""; // 重置token状态
          this.$successMsg(this.$I18n('succ_num'))
          setTimeout(() => {
            this.$router.push({
              path: "/login",
              query: { ...this.$router.history.current.query },
            })
          }, 1000)
        }))
        .catch(this.$Catch(this.$I18n("get_error")), () => {
          localStorage.acc_token = ""; // 重置token状态
          setTimeout(() => {
            this.$router.push({
              path: "/login",
              query: { ...this.$router.history.current.query },
            })
          }, 1000)
        })
    },
    checkExit(){
      this.openModal = true;
    },
    modal_classicModalHide(){
      this.openModal = false;
      this.openServerModal = false;
    },
    changeLanguage(lang){
      if (lang === "zh"){
        this.$router.push({query: {}})
      } else {
        this.$router.push({query: { lang }})
      }
      this.$router.go(0)
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
};
</script>
